import { Props } from "."

export const mockProps: Props = {
  label: "Tooltip label here",
  defaultOpen: true,
}
